module.exports = __webpack_public_path__ + "static/media/jo.6d688120.svg";